// GANTT FOR ALL PROJECTS
export const FETCH_GANTT_PROJECTS = "FETCH_GANTT_PROJECTS"
export const FETCH_GANTT_PROJECTS_FAIL = "FETCH_GANTT_PROJECTS_FAIL"
export const CLEAR_GANTT_PROJECTS = "CLEAR_GANTT_PROJECTS"
export const IS_LOADING_GANTT_PROJECTS = "IS_LOADING_GANTT_PROJECTS"

// GANT FOR ONE PROJECT
export const FETCH_GANTT_PROJECT = "FETCH_GANTT_PROJECT"
export const FETCH_GANTT_PROJECT_FAIL = "FETCH_GANTT_PROJECT_FAIL"
export const CLEAR_GANTT_PROJECT = "CLEAR_GANTT_PROJECT"
export const IS_LOADING_GANTT_PROJECT = "IS_LOADING_GANTT_PROJECT"
